/**
 * Toast — notification flottante avec icône, animation d'apparition.
 */
import { useEffect, useState } from "react";
import { colors, fonts } from "../styles/tokens";

const STYLES = {
  success: { color: colors.green, border: "rgba(45,212,160,0.40)", icon: "✓" },
  error:   { color: colors.rose,  border: "rgba(224,91,106,0.40)", icon: "✕" },
  warning: { color: colors.gold,  border: colors.goldBorder,       icon: "!" },
  info:    { color: colors.blue,  border: "rgba(96,165,250,0.40)", icon: "i" },
};

export default function Toast({ message, type = "info", onDismiss }) {
  const [visible, setVisible] = useState(false);
  const palette = STYLES[type] || STYLES.info;

  useEffect(() => {
    requestAnimationFrame(() => setVisible(true));
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onDismiss?.(), 200);
  };

  return (
    <div
      role="alert"
      style={{
        background: colors.card,
        color: colors.text,
        border: `1px solid ${palette.border}`,
        borderLeft: `4px solid ${palette.color}`,
        borderRadius: "10px",
        padding: "12px 16px",
        minWidth: "280px",
        maxWidth: "420px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.6)",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        fontFamily: fonts.body,
        fontSize: "14px",
        opacity: visible ? 1 : 0,
        transform: visible ? "translateX(0)" : "translateX(20px)",
        transition: "all 220ms ease-out",
      }}
    >
      <span
        style={{
          width: 24,
          height: 24,
          borderRadius: "50%",
          background: palette.color,
          color: colors.bg,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 700,
          flexShrink: 0,
        }}
      >
        {palette.icon}
      </span>
      <span style={{ flex: 1 }}>{message}</span>
      <button
        onClick={handleClose}
        aria-label="Fermer"
        style={{
          color: colors.textMuted,
          fontSize: "18px",
          padding: "0 4px",
          lineHeight: 1,
        }}
      >
        ×
      </button>
    </div>
  );
}
